<template>
    <v-card
        class="mx-auto"
        max-width="500"
        outlined
        elevation="2"
    >
        <v-form @submit.prevent="submit">
            <v-card-title class="justify-center">{{ $t('views.auth.reset_password.new_password') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="text-center">
                {{ $t('views.auth.reset_password.instructions') }}
            </v-card-text>
            <v-card-text>
                <v-text-field
                    v-model="form.email"
                    :label="$t('views.auth.reset_password.email_label')"
                    :error="$store.getters.hasValidationError('email')"
                    :error-messages="$store.getters.validationError('email')"
                ></v-text-field>

                <v-text-field
                    v-model="form.password"
                    :label="$t('views.auth.reset_password.password_label')"
                    :error="$store.getters.hasValidationError('password')"
                    :error-messages="$store.getters.validationError('password')"
                    :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordVisible ? 'text' : 'password'"
                    @click:append="passwordVisible = !passwordVisible"
                ></v-text-field>

                <v-text-field
                    v-model="form.password_confirmation"
                    :label="$t('views.auth.reset_password.password_confirmation_label')"
                    :append-icon="passwordConfirmVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordConfirmVisible ? 'text' : 'password'"
                    @click:append="passwordConfirmVisible = !passwordConfirmVisible"
                ></v-text-field>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
                <v-btn type="submit" color="success" rounded block :loading="resettingPassword">
                    {{ $t('views.auth.reset_password.reset_password_button') }}
                </v-btn>
            </v-card-actions>

            <v-card-text class="text-center">
                <router-link :to="{name: 'register'}">
                    {{ $t('views.auth.reset_password.register_link') }}
                </router-link>
                |
                <router-link :to="{name: 'login'}">
                    {{ $t('views.auth.reset_password.login_link') }}
                </router-link>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
export default {
        name: "ResetPassword",

        data() {
            return {
                passwordVisible: false,
                passwordConfirmVisible: false,
                resettingPassword: false,

                form: {
                    email: this.$route.query.email,
                    password: null,
                    password_confirmation: null,
                    token: this.$route.params.token,
                },
            };
        },

        methods: {
            submit: function() {

                if(this.resettingPassword) {
                    return;
                }

                this.resettingPassword = true;

                this.$store.dispatch('resetPassword', this.form)
                    .then(response => {
                        if(response.status !== 200) {
                            this.$store.commit(
                                "showSnackbarError",
                                this.$t('views.auth.reset_password.resetting_password_failed')
                            );
                            return;
                        }

                        this.$router.push({name: 'login'}).catch(() => {});
                    })
                    .catch(() => {})
                    .then(() => {
                        this.resettingPassword = false;
                    });
            },
        },
    }
</script>

<style scoped>

</style>
